{
  "title": "Immovable Object",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "2nd-level transmutation (dunamancy:graviturgy)",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (gold dust worth at least 25 gp, which the spell consumes)",
  "duration": "1 hour",
  "description": [
    "You touch an object that weighs no more than 10 pounds and cause it to become magically fixed in place. You and the creatures you designate when you cast this spell can move the object normally. You can also set a password that, when spoken within 5 feet of the object, suppresses this spell for 1 minute.",
    "If the object is fixed in the air, it can hold up to 4,000 pounds of weight. More weight causes the object to fall. Otherwise, a creature can use an action to make a Strength check against your spell save DC. On a success, the creature can move the object up to 10 feet.",
    "At Higher Levels. If you cast this spell using a spell slot of 4th or 5th level, the DC to move the object increases by 5, it can carry up to 8,000 pounds of weight, and the duration increases to 24 hours. If you cast this spell using a spell slot of 6th level or higher, the DC to move the object increases by 10, it can carry up to 20,000 pounds of weight, and the effect is permanent until dispelled."
  ],
  "spellLists": ["wizard"]
}
